const DATE_PICKER_DURATION = {
    LAST_7_DAYS: 'LAST_7_DAYS',
    LAST_4_WEEKS: 'LAST_4_WEEKS',
    LAST_3_MONTHS: 'LAST_3_MONTHS',
};

export { DATE_PICKER_DURATION };
